// extracted by mini-css-extract-plugin
export var button = "_j1-0";
export var donut = "_j1-1";
export var donutFill = "_j1-3";
export var donutTrack = "_j1-2";